/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState} from 'react'
import useApiOrderToCash from "../../api/operaciones/useApiOrderToCash";
import useForm from "../../shared/forms/useForm";
import Field from "../../shared/forms/Field";
import {Button} from "primereact/button";
import Form from "../../shared/forms/Form";
import {Dialog} from "primereact/dialog";
import FormInputFile from "../../shared/forms/FormFields/FormInputFile";
import moment from "moment";

const FacturasMasivas = ({visible,  onCancel, onSaved }) => {
    const api= useApiOrderToCash();
    const {
        values,
        onChange,
    } = useForm({hora:moment().format('HH:mm'), fecha:moment().startOf('day')._d});
    const [resultados, setResultados] = useState(null);
    const [visibleReporte, setVisibleReporte] =  useState(false);
    const onSave = async () => {       
        const formData = new FormData();
        formData.append("file", values.facturas.file);
        const response = await api.ligarFacturasMasivas(formData)
        console.log("Respuesta del backend:", response);
        setVisibleReporte(true)
        setResultados(response)
        await onSaved();
    }

    return (
        <>
            <Dialog header={`Subir Facturas Masivas`} visible={visible} style={{ width: '400px' }}
                    onHide={onCancel}>
                <Form values={values}
                      onChange={onChange}
                      className={`form-container`}
                >
                    <Field label="Excel" field={"facturas"} fileTypes={'.xlsx'} render={FormInputFile}/>
                   
                </Form>

                <div className="form-footer">
                    <Button label="Subir" className="p-button-outlined" type="button" onClick={onSave} />
                </div>
                
            </Dialog>
            <Dialog
                    header="Resultado de Facturas"
                    visible={visibleReporte}
                    style={{ width: "800px" }}
                    onHide={() => setVisibleReporte(false)}
                >
                    {resultados && (
                        <div>                         
                           
                            <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                                   <table className="table table-borderless">
                                    <thead className="thead-light">
                                        <tr>
                                           <th style={{width: '5%'}}>Fila</th>
                                            <th style={{width: '12%'}}>Carta Porte</th>
                                            <th style={{width: '13%'}}>Estado</th>
                                            <th style={{width: '15%'}}>Factura Actual</th>
                                            <th style={{width: '15%'}}>Factura Solicitada</th>
                                            <th style={{width: '48%'}}>Mensaje</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {resultados.detalles.map((d, idx) => {
                                            let icon = null;
                                            let color = "inherit";

                                            if (d.estado === "Actualizado") {
                                                icon = "pi pi-check";
                                                color = "green";
                                            } else if (d.estado === "Error") {
                                                icon = "pi pi-times";
                                                color = "red";                                                
                                            } else {
                                                icon = "pi pi-exclamation-triangle";
                                                color = "orange";
                                            }

                                            return (
                                                <tr key={idx}>
                                                    <td>{d.fila}</td>
                                                    <td>{d.cartaPorte}</td>
                                                    <td>
                                                        <i className={icon} style={{ color, marginRight: "6px" }} />
                                                        {d.estado}
                                                    </td>
                                                    <td>{d.facturaActual}</td>
                                                    <td>{d.facturaSolicitada}</td>
                                                    <td>{d.mensaje}</td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}
                </Dialog>

        </>
        
    )
}

export default FacturasMasivas;
